<div fxLayout="column" class="layout-padd" fxLayoutAlign="center center" [ngStyle]="{'max-height.px': innerHeight}"
    fxFlexFill>

    <div fxLayoutAlign="center center" class="text-center layout-padd">
        <span class="mat-subheading" *ngIf="orderHour"> {{'alertinvalidslotComponent.invalidtime' | translate}}</span>
        <span class="mat-subheading" *ngIf="!orderHour">{{'alertinvalidslotComponent.nomoretime' | translate}}</span>
    </div>

    <div fxLayoutAlign="center center" class="full-w" *ngIf="orderHour">

        <div fxLayoutAlign="center center" class="text-center warn rad-bord layout-padd"
            style="height: 50px; min-width: 100px;">
            <span class="mat-headline ">{{orderHour}}</span>
        </div>

    </div>

    <div class="layout-padd full-w">
        <button mat-stroked-button fxFlex class="dark-ico" (click)="closeDial()" angulartics2On="click"
            angularticsAction="closeInvalidSlotDial" angularticsCategory="order">
            <span class="mat-title">{{"dialogs.go-back" | translate}}</span>
        </button>
    </div>

</div>